<div class="out" kzLib (click)="clicked()" [style.background]="back_color" [style.border]="border" [ngClass]="{out_on:bOn}">
  <div [@openClose]="bOn ? 'open' : 'closed'" class="ball" [ngClass]="{ball_on:bOn}"></div>
</div>
